import password_rejected from './password-rejected.js';
const error = {
    general_required: `{{types, list(type: disjunction;)}} is required`,
    general_invalid: `Enter a valid {{types, list(type: disjunction;)}}.`,
    invalid_min_max_input: 'Enter a value between {{minValue}} and {{maxValue}}.',
    invalid_min_max_length: 'Use {{minLength}} to {{maxLength}} characters.',
    username_required: 'Username is required',
    password_required: 'Password is required',
    username_exists: 'Username already exists',
    username_should_not_start_with_number: 'Start your username with a letter or underscore.',
    username_invalid_charset: 'Use only letters, numbers, and underscores.',
    username_too_short: 'Username must be at least {{min}} characters long.',
    username_too_long: 'Username must be at most {{max}} characters long.',
    username_uppercase_not_allowed: 'Use only lowercase letters in your username.',
    username_lowercase_not_allowed: 'Use only uppercase letters in your username.',
    username_numbers_not_allowed: 'Numbers are not allowed in usernames.',
    username_underscore_not_allowed: 'Underscores are not allowed in usernames.',
    invalid_email: 'Enter a valid email, like name@example.com',
    invalid_phone: 'Enter a valid phone number',
    passwords_do_not_match: 'Your passwords don’t match.',
    invalid_passcode: 'That code doesn’t match. Check it or request a new code.',
    device_code_required: 'Code is required.',
    invalid_device_code: 'That code doesn’t match. Check the code on your device and try again.',
    device_flow_aborted: 'The sign-in request was interrupted. Start again from your device.',
    invalid_connector_auth: 'Unable to sign in with this account. Go back and try again.',
    invalid_connector_request: 'Unable to sign in with this account. Go back and try again.',
    unknown: 'Unable to continue. Check your connection and try again.',
    invalid_session: 'Session not found. Please go back and sign in again.',
    timeout: 'The request took too long. Check your connection and try again.',
    password_rejected,
    sso_not_enabled: 'Single sign-on isn’t set up for this email.',
    invalid_link: 'Invalid link',
    invalid_link_description: 'Your one-time token may have expired or is no longer valid.',
    captcha_verification_failed: 'Unable to confirm you’re human. Reload the page and try again.',
    send_verification_code_failed: 'Failed to send the verification code. Please try again later.',
    send_verification_code_failed_use_password: 'Failed to send the verification code. Please sign in with your password instead.',
    terms_acceptance_required: 'Terms acceptance required',
    terms_acceptance_required_description: 'You must agree to the terms to continue.',
    something_went_wrong: 'Something went wrong',
    account_suspended: 'Account suspended',
    account_suspended_description: 'This account has been suspended. Please contact the administrator for assistance.',
    access_denied: 'Access denied',
    application_access_denied: 'You do not have permission to access this application.\nPlease contact your administrator for assistance.',
    feature_not_enabled: 'You do not have permission to access this feature. Please contact your administrator for assistance.',
    wallet_not_found: 'No Ethereum wallet detected. Install a browser wallet extension and try again.',
    wallet_not_supported: 'Wallet sign-in is only supported in a browser with an installed wallet extension.',
    wallet_request_rejected: 'The wallet request was rejected. Please try again.',
    wallet_unsupported_chain: 'Your wallet is connected to an unsupported network. Switch networks and try again.',
    wallet_signature_invalid: 'The wallet signature is invalid or has expired. Please try again.',
};
export default Object.freeze(error);
